/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fix_GramsInputs */

const en_fix_grams = /** @type {(inputs: Fix_GramsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grams in the recipe`)
};

const de_fix_grams = /** @type {(inputs: Fix_GramsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gramm im Rezept`)
};

/**
* | output |
* | --- |
* | "Grams in the recipe" |
*
* @param {Fix_GramsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_grams = /** @type {((inputs?: Fix_GramsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_GramsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_grams(inputs)
	return en_fix_grams(inputs)
});